<template>
    <div>
        <viewer v-if="isKonfirmasi" :value="form" is-konfirmasi @koreksi="koreksi" @ok="save(true)"></viewer>
        <b-card v-show="!isKonfirmasi" v-if="form" class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Edit' : 'Buat' }} Surat Jalan</h5>
            </b-card-header>
            <b-card-body>
                <div class="form-group">
                    <label class="form-control-label">Tipe Surat</label>
                    <div class="input-group single mb-0 d-flex">
                        <multiselect :disabled="isEdit" class='w-auto flex-grow-1' v-validate="'required'" name="tipe" v-model="type" :options="typeOptions" :placeholder="'Pilih tipe surat'" :searchable="true"
                            label="label" track-by="value" :allowEmpty="false" :show-labels="false"></multiselect>
                    </div>
                    <span class="text-danger">{{ errors.first('tipe') }}</span>
                </div>

                <div v-show="isPindahGudang" class="mb-3">
                    <div class="form-group mb-0">
                        <label class="form-control-label">Pindah Gudang</label>
                        <div class="input-group mb-0 d-flex-inline">
                            <multiselect :disabled="isEdit" class="w-auto flex-grow-1" v-validate="isPindahGudang ? 'required' : ''" name="pindah_gudang" v-model="form.pindah_gudang" :options="pindahGudangOptions" :placeholder="'Pilih pindah gudang'" :searchable="true"
                                :custom-label="pindahGudangLabel" :allowEmpty="false" track-by="id" :show-labels="false"></multiselect>
                            <div v-if="!isEdit" class="input-group-append">
                                <button class="btn btn-primary" type="button" @click="selectPindahGudang = true"><i class="fas fa-search"></i> Pilih</button>
                            </div>
                        </div>
                        <span class="text-danger">{{ errors.first('pindah_gudang') }}</span>
                    </div>

                    <div class="row" v-if="form.pindah_gudang">
                        <div class="col">
                            <strong class="text-primary">{{ form.pindah_gudang.gudang_asal.name }}</strong>
                            ke
                            <strong class="text-primary">{{ form.pindah_gudang.gudang_tujuan.name }}</strong>
                        </div>
                    </div>
                </div>

                <div v-show="isReDry" class="mb-3">
                    <div class="form-group mb-0">
                        <label class="form-control-label">Re Dry</label>
                        <div class="input-group mb-0 d-flex-inline">
                            <multiselect :disabled="isEdit" class="w-auto flex-grow-1" v-validate="isReDry ? 'required' : ''" name="re_dry" v-model="form.re_dry" :options="reDryOptions" :placeholder="'Pilih re dry'" :searchable="true"
                                :custom-label="reDryLabel" :allowEmpty="false" track-by="id" :show-labels="false"></multiselect>
                            <div v-if="!isEdit" class="input-group-append">
                                <button class="btn btn-primary" type="button" @click="selectReDry = true"><i class="fas fa-search"></i> Pilih</button>
                            </div>
                        </div>
                        <span class="text-danger">{{ errors.first('re_dry') }}</span>
                    </div>

                    <div class="row" v-if="form.re_dry">
                        <div class="col">
                            <strong class="text-primary">{{ form.re_dry.gudang.name }}</strong>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Admin Gudang</label>
                    <input v-validate="'required'" v-model="form.admin_gudang" type="text" name="admin_gudang" class="form-control">
                    <span class="text-danger">{{ errors.first('admin_gudang') }}</span>
                </div>

                <div class="form-group">
                    <label>Sopir</label>
                    <input v-validate="'required'" v-model="form.driver" type="text" name="sopir" class="form-control">
                    <span class="text-danger">{{ errors.first('sopir') }}</span>
                </div>

                <div v-if="type && type.value == 're_dry'" class="form-group">
                    <label>Vendor</label>
                    <input v-validate="'required'" v-model="form.vendor" type="text" name="vendor" class="form-control">
                    <span class="text-danger">{{ errors.first('vendor') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                <button v-if="isEdit" :disabled="isLoading" @click="save" type="button" class="btn btn-primary mr-2">Simpan</button>
                <button v-else :disabled="isLoading" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Simpan</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectPindahGudang" size="lg" :hide-header="true" :hide-footer="true">
            <pindah-gudang-selector :selected="pindahGudangOptions" @selected="pindahGudangSelected" @cancel="selectPindahGudang = false"></pindah-gudang-selector>
        </b-modal>

        <b-modal v-model="selectReDry" size="lg" :hide-header="true" :hide-footer="true">
            <re-dry-selector :selected="reDryOptions" @selected="reDrySelected" @cancel="selectReDry = false"></re-dry-selector>
        </b-modal>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Viewer from './Viewer';
import Multiselect from 'vue-multiselect';
import PindahGudangSelector from '../pindah-gudangs/Selector';
import ReDrySelector from '../re-dries/Selector';

export default {
    name: "surat-jalan-form",

    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        DatePicker,
        Viewer,
        Multiselect,
        PindahGudangSelector,
        ReDrySelector,
    },

    data() {
        return {
            form: null,
            isKonfirmasi: false,
            type: null,
            typeOptions: [
                {
                    value: 'pindah_gudang',
                    label: 'Pindah Gudang',
                },
                {
                    value: 're_dry',
                    label: 'Re Dry',
                },
            ],
            selectPindahGudang: false,
            pindahGudangOptions: [],
            selectReDry: false,
            reDryOptions: [],
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        if (this.value) {
            this.initForm();
        }
    },

    computed: {
        suratable() {
            if (this.type.value == 'pindah_gudang') {
                return this.form.pindah_gudang;
            } else if (this.type.value == 're_dry') {
                return this.form.re_dry;
            }
        },

        isPindahGudang() {
            return this.type && this.type.value == 'pindah_gudang';
        },

        isReDry() {
            return this.type && this.type.value == 're_dry';
        },
    },

    watch: {
        value() {
            this.form = Object.assign({}, this.value);
        }
    },

    methods: {
        resetForm() {
            this.type = Object.assign({}, {
                value: 'pindah_gudang',
                label: 'Pindah Gudang',
            });
            this.form = Object.assign({}, {
                name: null,
                tanggal_pembelian: null,
                jumlah: null,
                harga: null,
                total: null,
            });
        },

        initForm() {
            let self = this;

            self.form = Object.assign({}, self.value);
            if (self.form.suratable) {
                if (self.form.type == 'pindah_gudang') {
                    self.pindah_gudang = Object.assign({}, self.form.suratable);
                } else if (self.form.type == 're_dry') {
                    self.re_dry = Object.assign({}, self.form.suratable);
                }
            }
            if (self.isEdit) {
                let typeIndex = self.typeOptions.findIndex(option => option.value == self.form.type);
                self.type = Object.assign({}, self.typeOptions[typeIndex]);
                if (self.form.type == 'pindah_gudang') {
                    self.form.pindah_gudang = Object.assign({}, self.form.suratable);
                } else if (self.form.type == 're_dry') {
                    self.form.re_dry = Object.assign({}, self.form.suratable);
                }
            }
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    if (self.type.value == 'pindah_gudang') {
                        self.form.suratable = Object.assign({}, self.form.pindah_gudang);
                    } else if (self.type.value == 're_dry') {
                        self.form.suratable = Object.assign({}, self.form.re_dry);
                    }
                    self.form.type = self.type;
                    self.isKonfirmasi = true;
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save(isPrint = false) {
            let self = this;

            self.isLoading = true;

            let data = {
                admin_gudang: self.form.admin_gudang,
                driver: self.form.driver,
                vendor: self.type.value == 're_dry' ? self.form.vendor : null,
            }

            if (!self.isEdit) {
                data.type = self.type.value;
                data.suratable_id = self.suratable.id;
            }

            let api = self.isEdit ? '/api/surat-jalans/'+self.form.id : '/api/surat-jalans';

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.isLoading = false;
                if (isPrint) {
                    self.print(response.data.data.id);
                }
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        pindahGudangSelected(pindahGudang) {
            let self = this;

            self.pindahGudangOptions = [];
            self.pindahGudangOptions.push(pindahGudang);
            self.form.pindah_gudang = Object.assign({}, pindahGudang);
            self.selectPindahGudang = false;
        },

        reDrySelected(reDry) {
            let self = this;

            self.reDryOptions = [];
            self.reDryOptions.push(reDry);
            self.form.re_dry = Object.assign({}, reDry);
            self.selectReDry = false;
        },

        pindahGudangLabel({ tanggal_berangkat }) {
            return `[${this.formatDate(tanggal_berangkat)}]`
        },

        reDryLabel({ tanggal_berangkat }) {
            return `[${this.formatDate(tanggal_berangkat)}]`
        },

        print(id) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/surat-jalans/print/' + (id || self.suratJalan.id);
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },
    },
}
</script>
